import { render, staticRenderFns } from "./DashboardConsumptionBreakdown.vue?vue&type=template&id=5e63c861&scoped=true"
import script from "./DashboardConsumptionBreakdown.vue?vue&type=script&lang=js"
export * from "./DashboardConsumptionBreakdown.vue?vue&type=script&lang=js"
import style0 from "./DashboardConsumptionBreakdown.vue?vue&type=style&index=0&id=5e63c861&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e63c861",
  null
  
)

export default component.exports